const CHANGED_RESPONSES = new Set([
  'question updated',
  'ria questionnaire restored',
  'ria questionnaire created',
  'questionnaire changed',
]);

export default class Risk {
  constructor() {
    this.questions = [];
    this.lastUpdate = null;
    this.riskToleranceId = null;
    this.isComplete = null;
    this.score = null;
    this.overrideScore = null;
    this.scaleRange = null;
    this.gotoQuestion = null;
    this.showChangedAlert = false;
    this.isOverrideActive = null;
    this.sliderScore = null;
    this.currentQuestionnaireScore = null;
    this.addAccountRetake = false;
    this.riskLabel = null;
    this.riskDescription = null;
    this.isRiskLoaded = false;
  }

  static formatResponse(response) {
    // eslint-disable-next-line no-param-reassign
    response.lastAnswered = null;

    response.questionnaire.questions.forEach((question, questionIndex) => {
      // mark all the answers as unselected
      question.answers.forEach((answer) => {
        // eslint-disable-next-line no-param-reassign
        answer.selected = false;
      });

      // mark the proper answers as selected
      response.answers.forEach((answer) => {
        const answerIndex = question.answers.findIndex(
          (onQuestion) => answer.risk_tolerance_answer_id.toString() === onQuestion.risk_tolerance_answer_id.toString()
        );

        if (answerIndex >= 0) {
          // eslint-disable-next-line no-param-reassign
          question.answers[answerIndex].selected = true;

          // eslint-disable-next-line no-param-reassign
          response.lastAnswered =
            questionIndex === response.questionnaire.questions.length - 1 ? questionIndex : questionIndex + 1;
        }
      });
    });

    return response;
  }

  static hasQuizChanged(response) {
    return CHANGED_RESPONSES.has(response);
  }
}
